(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;

  const EVENTS = {};
  for (const name of [
    "attached", "attack", "banished", "beginningPhase", "buffed", "burned", "channel", "chainResolved", "chained",
    "combatEnd", "combatStart", "conquer", "defend", "detached", "dies", "discarded", "discardedBatch", "draw",
    "empowered", "endOfTurn", "finalizedCard", "hidden", "hold", "leavesBoard", "mainPhase", "move", "played", "ready",
    "recalled", "recycleRune", "recycled", "recycledCards", "resolving", "revealCards", "runeExhausted", "scored",
    "showdownStart", "spellResolved", "stunned", "takeDamage", "targeted", "toDeck", "toHand", "unitConquer", "unitHold",
    "becameMighty", "buffSpent", "revealedFromDeck", "delayedEffect", "peekFacedown",
  ]) EVENTS[name] = true;

  const FX = {
    EVENTS: EVENTS,
    OPS: {},

    emit(state, ev) {
      if (!EVENTS[ev.type]) throw new Error("unknown event type " + ev.type);
      Kernel.record(ev);
      if (ev.type === "revealCards" && ev.iids && !ev.private) FX.runRevealTriggers(state, ev);
      if (RB.Scripts.subscribedEvents()[ev.type]) FX.collectTriggers(state, ev);
      FX.collectDelayedTriggers(state, ev);
    },

    runRevealTriggers(state, ev) {
      for (const iid of ev.iids) {
        const o = state.objs[iid];
        if (!o) continue;
        const sc = RB.Scripts.forCard(state, iid);
        for (const trig of (sc && sc.revealTriggers) || []) {
          if (trig.fromZone && trig.fromZone !== ev.source) continue;
          const item = {
            controller: o.owner, source: iid, iid: iid, kind: "reveal",
            targets: {}, vars: {}, ctx: { ev: ev }, pc: 0,
            label: Core.name(state, iid) + ": " + (trig.label || "revealed"),
          };
          Core.log(state, item.label + ".", { k: "trigger", p: o.owner, iids: [iid] });
          for (const op of trig.program || []) FX.runOp(state, item, op);
        }
      }
    },

    emitHeard(state, ev) {
      if (!FX.anyListener(state, ev.type)) return;
      FX.emit(state, ev);
    },

    delayedListener(state, type) {
      return (state.fx || []).some(function (f) { return f.k === "delayedTrigger" && f.on === type; });
    },

    triggerSources(state) {
      const sources = Core.effectSources(state, { battlefields: false });
      for (const pl of state.players) for (const tIid of pl.trash) sources.push(tIid);
      return sources;
    },

    triggerLists(state, iid) {
      const o = state.objs[iid];
      const script = o && RB.Scripts.forCard(state, iid);
      if (!script) return null;
      const lists = [{ trigs: (o.zone === "trash" ? script.trashTriggers : script.triggers) || [], from: iid }];
      const aliases = [];
      if (o.zone === "board") {
        for (const aIid of o.attachments || []) {
          const asc = RB.Scripts.forCard(state, aIid);
          if (!asc) continue;
          if (asc.attachedTriggers) lists.push({ trigs: asc.attachedTriggers, from: aIid });
          if (asc.attachedCopyHost) lists.push({ trigs: script.triggers || [], from: aIid });
          if (asc.attachedEventAlias) aliases.push(asc.attachedEventAlias);
        }
      }
      return { lists: lists, aliases: aliases };
    },

    anyListener(state, type) {
      if (!RB.Scripts.subscribedEvents()[type]) return FX.delayedListener(state, type);
      for (const iid of FX.triggerSources(state)) {
        const tl = FX.triggerLists(state, iid);
        if (!tl) continue;
        for (const alias of tl.aliases) {
          for (const k in alias) if (alias[k] === type) return true;
        }
        for (const entry of tl.lists) {
          for (const t of entry.trigs) if (t.on === type) return true;
        }
      }
      return FX.delayedListener(state, type);
    },

    collectTriggers(state, ev) {
      for (const iid of FX.triggerSources(state)) {
        const o = state.objs[iid];
        if (o.attachedTo) continue;
        const tl = FX.triggerLists(state, iid);
        if (!tl) continue;
        let alias = null;
        for (const a of tl.aliases) alias = Object.assign(alias || {}, a);
        const firedLabels = {};
        for (const entry of tl.lists) {
          for (const trig of entry.trigs) {
            if (!FX.trigMatches(state, iid, trig, ev, alias)) continue;

            const labelKey = entry.from + "|" + (trig.label || trig.on);
            if (firedLabels[labelKey]) continue;
            firedLabels[labelKey] = 1;
            if (trig.oncePerTurn) {
              const key = "opt" + entry.from + trig.on + state.turn.num +
                (trig.perPlayer && ev.player !== undefined ? "p" + ev.player : "");
              if (o.flags[key]) continue;
              o.flags[key] = 1;
            }

            if (trig.onceKey) {
              const okey = "opk" + trig.onceKey + state.turn.num;
              if (o.flags[okey]) continue;
              o.flags[okey] = 1;
            }
            const label = Core.name(state, entry.from) + ": " + (trig.label || trig.on);
            if (trig.exhaustSelf && state.triggerQueue.some(function (q) { return q.source === iid && q.label === label; })) continue;
            const times = FX.triggerTimes(state, ev);
            for (let rep = 0; rep < times; rep++) {
              state.triggerQueue.push({
                controller: trig.controllerFromEvent && ev.player !== undefined ? ev.player : FX.trigController(state, iid, trig, ev),
                source: iid,
                label: label,
                program: trig.program,
                targetSpecs: trig.targets || [],
                optional: !!trig.optional,
                exhaustSelf: !!trig.exhaustSelf,
                ctx: {
                  ev: ev,
                  bf: ev.bf || (o.loc && o.loc.t === "bf" ? o.loc.iid : null) ||
                    ((state.battlefields || []).indexOf(iid) >= 0 ? iid : null),
                  via: entry.from !== iid ? entry.from : null,
                },
              });
              if (trig.exhaustSelf) break;
            }
          }
        }
      }
    },

    triggerTimes(state, ev) {
      return 1 + FX.extraScoreTriggers(state, ev.type, ev.bf, ev.player);
    },

    extraScoreTriggers(state, evType, bfIid, p) {
      const key = evType === "unitConquer" || evType === "conquer" ? "conquerAgainHere"
        : evType === "unitHold" || evType === "hold" ? "holdAgainHere" : null;
      if (!key || !bfIid || p === undefined || p === null) return 0;
      let extra = 0;
      for (const iid of Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) { return o.controller === p; })) {
        const sc = RB.Scripts.forCard(state, iid);
        if (sc && sc[key]) extra += sc[key];
      }
      const bsc = RB.Scripts.forCard(state, bfIid);
      if (bsc && bsc[key] && state.objs[bfIid].controller === p) extra += bsc[key];
      return extra;
    },

    collectDelayedTriggers(state, ev) {
      for (const f of state.fx) {
        if (f.k !== "delayedTrigger") continue;
        if (f.on !== ev.type) continue;
        if (f.expiresTurn !== undefined && state.turn.num !== f.expiresTurn) { f.done = true; continue; }
        if (f.player !== undefined && ev.player !== undefined && f.player !== ev.player) continue;
        if (f.iid !== undefined && f.iid !== null &&
          ev.iid !== f.iid && !(ev.snapshot && ev.snapshot.iid === f.iid)) continue;
        if (f.condSpec && !FX.evalCond(state, f.condSpec, { iid: f.source, p: f.controller, ev: ev })) continue;
        if (!f.repeat) f.done = true;
        state.triggerQueue.push({
          controller: f.controller,
          source: f.source || null,
          cardId: f.cardId || null,
          label: f.label || "Delayed effect",
          program: f.program,
          targetSpecs: f.targets || [],
          carry: f.carry || null,
          vars: f.carryVars || null,
          ctx: { ev: ev, bf: ev.bf || null },
        });
      }
      state.fx = state.fx.filter(function (f) { return !f.done; });
    },

    trigMatches(state, iid, trig, ev, alias) {
      if (trig.on !== ev.type && !(alias && alias[trig.on] === ev.type)) return false;
      const o = state.objs[iid];
      if (trig.self) {
        if (ev.iid !== iid) return false;
      }
      if (trig.selfBf) {
        if (!ev.bf) return false;
        if (o.zone !== "board") return false;
        const here = o.loc && o.loc.t === "bf" && o.loc.iid === ev.bf;
        const isBfItself = iid === ev.bf;
        if (!here && !isBfItself) return false;
      }
      if (trig.you) {
        if (ev.player === undefined) return false;
        if (iid === ev.bf) {
          if (state.objs[iid].controller !== ev.player) return false;
        } else if (o.controller !== ev.player) return false;
      }
      if (trig.friendlyUnit) {
        if (!ev.snapshot && !ev.iid) return false;
        const ctrl = ev.snapshot ? ev.snapshot.controller : state.objs[ev.iid] && state.objs[ev.iid].controller;
        if (ctrl !== o.controller) return false;
        const evIid = ev.snapshot ? ev.snapshot.iid : ev.iid;
        if (evIid === iid) return false;
      }
      if (trig.cond && !trig.cond(state, iid, ev)) return false;
      if (trig.condSpec && !RB.Scripts.trigCond(state, iid, ev, trig.condSpec)) return false;
      return true;
    },

    trigController(state, iid, trig, ev) {
      const o = state.objs[iid];
      if (iid === ev.bf && Core.isType(state, iid, "battlefield")) {
        return o.controller !== null && o.controller !== undefined ? o.controller : state.turn.player;
      }
      return o.controller;
    },

    emitPlayTriggers(state, iid, item) {
      const o = state.objs[iid];
      const script = RB.Scripts.forCard(state, iid);
      const ctxBf = o.loc && o.loc.t === "bf" ? o.loc.iid : null;
      if (script && script.play && script.play.length) {
        state.triggerQueue.push({
          controller: item.controller,
          source: iid,
          label: Core.name(state, iid) + ": play effect",
          program: script.play,
          targetSpecs: script.targets || [],
          optional: !!script.playOptional,
          ctx: { bf: ctxBf, fromFacedown: item.fromFacedown, hiddenBf: item.hiddenBf },
        });
      }
      const kws = Core.keywords(state, iid);
      const playHasOp = function (opName) {
        return !!(script && script.play && script.play.some(function (o2) { return o2.op === opName; }));
      };
      if (kws.weaponmaster && !playHasOp("weaponEquip")) {
        state.triggerQueue.push({
          controller: item.controller, source: iid,
          label: Core.name(state, iid) + ": Weaponmaster",
          program: [{ op: "weaponEquip" }],
          optional: true,
          ctx: {},
        });
      }
      if (kws["quick-draw"] && !playHasOp("attachSource") && Core.isType(state, iid, "gear") &&
        (script && (script.abilities || []).some(function (ab) { return ab.label === "Equip"; }))) {
        state.triggerQueue.push({
          controller: item.controller, source: iid,
          label: Core.name(state, iid) + ": Quick-Draw",
          program: [{ op: "attachSource", to: "$_qd" }],
          targetSpecs: [{ bind: "_qd", spec: { type: "unit", friendly: true }, prompt: "Attach " + Core.name(state, iid) + " to which unit?" }],
          ctx: {},
        });
      }
      if (kws.vision && !playHasOp("predict")) {
        state.triggerQueue.push({
          controller: item.controller, source: iid,
          label: Core.name(state, iid) + ": Vision",
          program: [{ op: "predict", n: 1 }],
          ctx: {},
        });
      }
      if (script && script.unscripted && (script.manualLines || []).length) {
        state.triggerQueue.push({
          controller: item.controller, source: iid,
          label: Core.name(state, iid) + ": unscripted text",
          program: [{ op: "manual", note: "Card text is not automated - apply it manually:\n" + script.manualLines.join("\n") }],
          ctx: {},
        });
      }
    },

    collectLeaveTriggers(state, iid) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board") return;
      const script = RB.Scripts.forCard(state, iid);
      const snapshot = {
        iid: iid, name: Core.name(state, iid), loc: o.loc,
        controller: o.controller, owner: o.owner,
      };
      for (const trig of (script && script.triggers) || []) {
        if (trig.on !== "leavesBoard") continue;
        state.triggerQueue.push({
          controller: o.controller,
          source: null,
          cardId: Core.cardId(state, iid),
          label: snapshot.name + ": " + (trig.label || "leaves the board"),
          program: trig.program,
          targetSpecs: trig.targets || [],
          optional: !!trig.optional,
          exhaustSelf: !!trig.exhaustSelf,
          ctx: { snapshot: snapshot, bf: o.loc && o.loc.t === "bf" ? o.loc.iid : null },
        });
      }
    },

    collectDeathTriggers(state, iid, snapshot) {
      const script = RB.Scripts.forCard(state, iid);
      const o = state.objs[iid];
      const snapBf = snapshot.loc && snapshot.loc.t === "bf" ? snapshot.loc.iid : null;

      for (const trig of (script && script.triggers) || []) {
        if (trig.on !== "dies") continue;
        const ev = { type: "dies", snapshot: snapshot };
        if (trig.cond && !trig.cond(state, iid, ev)) continue;
        if (trig.condSpec && !RB.Scripts.trigCond(state, iid, ev, trig.condSpec)) continue;
        if (!trig.self && !trig.cond && !trig.condSpec) continue;
        state.triggerQueue.push({
          controller: o.controller,
          source: null,
          cardId: Core.cardId(state, iid),
          label: snapshot.name + ": " + (trig.label || "dies"),
          program: trig.program,
          targetSpecs: trig.targets || [],
          optional: !!trig.optional,
          exhaustSelf: !!trig.exhaustSelf,
          ctx: { snapshot: snapshot, bf: snapBf },
        });
      }
      for (const aIid of o.attachments || []) {
        const asc = RB.Scripts.forCard(state, aIid);
        if (!asc) continue;
        const grantedDk = asc.attachedDeathknell || (asc.attachedCopyHost && script && script.deathknell) || null;
        if (!grantedDk) continue;
        state.triggerQueue.push({
          controller: o.controller,
          source: null,
          cardId: Core.cardId(state, aIid),
          label: snapshot.name + ": Deathknell (" + Core.name(state, aIid) + ")",
          program: grantedDk,
          targetSpecs: (asc.attachedDeathknell ? asc.attachedDeathknellTargets : script.deathknellTargets) || [],
          ctx: { snapshot: snapshot, via: aIid, bf: snapBf },
        });
      }
      const scriptedDk = script && script.deathknell;
      if (scriptedDk && scriptedDk.length) {
        state.triggerQueue.push({
          controller: o.controller,
          source: null,
          cardId: Core.cardId(state, iid),
          label: snapshot.name + ": Deathknell",
          program: script.deathknell,
          targetSpecs: script.deathknellTargets || [],
          ctx: { snapshot: snapshot, bf: snapBf },
        });
      } else if (!scriptedDk && Core.hasKw(state, iid, "deathknell")) {
        state.triggerQueue.push({
          controller: o.controller,
          source: null,
          cardId: Core.cardId(state, iid),
          label: snapshot.name + ": Deathknell (unscripted)",
          program: [{ op: "manual", note: "Deathknell of " + snapshot.name + " is not automated - apply it manually:\n" + (script ? script.rulesLines : []).join("\n") }],
          ctx: { snapshot: snapshot },
        });
      }
    },

    opLog(state, item, kind, msg, iids, tgt) {
      const src = item.iid || item.source;
      Core.log(state, msg, {
        k: kind,
        p: item.controller,
        iids: (src ? [src] : []).concat(iids || []),
        tgt: tgt || [],
      });
    },

    chainEvent(type, item, extra) {
      const ev = {
        type: type, id: item.id, iid: item.iid || null, source: item.source || null,
        cardId: item.cardId || null,
        controller: item.controller, label: item.label, kind: item.kind,
      };
      if (type !== "chainResolved") {
        ev.snapshot = item.ctx && item.ctx.snapshot ? { iid: item.ctx.snapshot.iid, loc: item.ctx.snapshot.loc } : null;
      }
      return Object.assign(ev, extra || {});
    },

    stepResolve(state, frame) {
      const item = frame.direct || RB.Play.itemById(state, frame.chainId);
      if (!item) return "done";
      const prog = item.program || [];
      if (item.pc >= prog.length) {
        FX.finishResolve(state, item, frame);
        return "done";
      }
      const op = prog[item.pc];
      const res = FX.runOp(state, item, op);
      if (res === "wait") return "wait";

      if (res !== "repeat") item.pc += 1;
      return "again";
    },

    finishResolve(state, item, frame) {
      if (!frame.direct) RB.Play.removeChainItem(state, item.id);
      if (item.kind === "spell" && item.iid) {
        const o = state.objs[item.iid];
        if (o && o.zone === "chain") {
          if (item.flowPlayed || item.banishOnResolve) {
            const nid = Flow.toBanish(state, item.iid);
            if (item.banishWithSrc) FX.recordBanishedWith(state, item.banishWithSrc, nid);
          } else if (item.recycleOnResolve) {
            Flow.recycleCards(state, [item.iid]);
          } else {
            Flow.toTrash(state, item.iid);
          }
        }
        RB.FX.emit(state, { type: "spellResolved", player: item.controller, iid: item.iid });
      }
      if (!frame.direct) {
        RB.FX.emit(state, FX.chainEvent("chainResolved", item, { left: state.chain.length }));
      }
      state.passCount = 0;
      state.needCleanup = true;
      if (state.chain.length) {
        const finalized = state.chain.filter(function (it) { return it.status === "finalized"; });
        if (finalized.length && !state.chain.some(function (it) { return it.status === "pending"; })) {
          state.priority = finalized[finalized.length - 1].controller;
        }
      } else {
        state.priority = null;
        if (state.showdown && state.showdown.stage === "open") {
          if (state.chainOpener === "play") {
            state.showdown.focus = Core.otherPlayer(state.showdown.focus);
            state.showdown.passes = 0;
          }
        }
        state.chainOpener = null;
      }
    },

    recordBanishedWith(state, srcIid, nid) {
      const src = state.objs[srcIid];
      if (!src || !nid) return;
      (src.flags.banishedWith = src.flags.banishedWith || []).push(nid);
      const ssc = RB.Scripts.forCard(state, srcIid);
      const payoff = ssc && ssc.banishedWithPayoff;
      if (!payoff || src.flags.banishedWith.length < payoff.n) return;
      state.triggerQueue.push({
        controller: src.controller,
        source: srcIid,
        label: Core.name(state, srcIid) + ": " + (payoff.label || "banished-with payoff"),
        program: payoff.program,
        targetSpecs: [],
        ctx: {},
      });
    },

    resolveRef(state, item, ref) {
      if (ref === "self" || ref === "source") {
        return item.source ? [item.source] : item.iid ? [item.iid] : [];
      }
      if (ref === "$ev") {
        const ev = item.ctx && item.ctx.ev;
        if (ev && ev.iid && state.objs[ev.iid]) return [ev.iid];
        return [];
      }
      if (typeof ref === "string" && ref.charAt(0) === "$") {
        const arr = item.targets[ref.slice(1)] || [];
        return arr.filter(function (t) {
          if (typeof t === "string" && t.indexOf("chain:") === 0) return true;
          const o = state.objs[t];
          return o && (o.zone === "board" || o.zone === "trash" || o.zone === "hand" ||
            o.zone === "champion" || o.zone === "banish" || o.zone === "facedown" ||
            o.zone === "legendZone");
        });
      }
      return [];
    },

    refsOrSpec(state, item, op) {
      if (op.spec) return RB.Play.candidates(state, op.spec, item);
      if (op.iid) return state.objs[op.iid] ? [op.iid] : [];
      return FX.resolveRef(state, item, op.to);
    },

    targetsOf(state, item, op) {
      let tgts = FX.refsOrSpec(state, item, op);
      let atBf = null;
      if (op.at) {
        const anchors = FX.resolveRef(state, item, op.at);
        if (!anchors.length) return null;
        atBf = anchors[0];
      }
      if (op.atVar) {
        const loc = item.vars[op.atVar];
        if (!loc || loc.t !== "bf") return null;
        atBf = loc.iid;
      }
      if (op.except) {
        const ex = item.targets[op.except] || [];
        tgts = tgts.filter(function (t) { return ex.indexOf(t) < 0; });
      }
      if (atBf) {
        tgts = tgts.filter(function (t) {
          const o = state.objs[t];
          return o.loc && o.loc.t === "bf" && o.loc.iid === atBf;
        });
      }
      return tgts;
    },

    flooredMight(state, iid, op) {
      if (op.might >= 0 || op.floor === undefined) return op.might;
      const cur = Core.effMight(state, iid);
      if (cur === null) return op.might;
      const allowed = Math.max(0, cur - op.floor);
      return -Math.min(-op.might, allowed);
    },

    stepLookPlay(state, item, key, set, p) {
      const doneKey = key + "LookPlay";
      const done = item.vars[doneKey] || [];
      for (const iid of set) {
        if (done.indexOf(iid) >= 0) continue;
        const o = state.objs[iid];
        if (!o || o.owner !== p) continue;
        const sc = RB.Scripts.forCard(state, iid);
        if (!sc || !sc.lookPlayCost) continue;
        const cost = RB.Play.costFromRes(sc.lookPlayCost, Core.card(state, iid).domains);
        if (!RB.Play.poolPotentialCovers(state, p, cost, {})) { item.vars[doneKey] = done.concat([iid]); return "repeat"; }
        const askKey = key + "lp" + iid;
        if (FX.ask(state, item, askKey, {
          player: p, tag: "may", options: ["Yes", "No"],
          prompt: "Play " + Core.name(state, iid) + " from the cards you are looking at?",
        })) return "wait";
        if (item.vars[askKey] !== 0) {
          item.vars[doneKey] = done.concat([iid]);
          return "repeat";
        }
        if (FX.askPay(state, item, askKey + "Paid", p, cost, Core.name(state, iid))) return "wait";
        item.vars[doneKey] = done.concat([iid]);
        const idx = set.indexOf(iid);
        if (idx >= 0) set.splice(idx, 1);
        RB.Play.beginPlay(state, p, iid, { fromZone: "deck", viaEffect: true, waive: "all" });
        Core.log(state, state.players[p].name + " plays " + Core.name(state, iid) + " from the cards they were looking at.",
          { k: "play", p: p, iids: [iid] });
        return "repeat";
      }
      return null;
    },

    ask(state, item, key, pd) {
      if (item.vars[key] !== undefined) return false;
      state.pending = Object.assign({
        kind: "choose", player: item.controller, src: item.label, srcIid: item.iid, varKey: key,
      }, pd);
      return true;
    },

    askPay(state, item, key, player, cost, note) {
      if (item.vars[key]) return false;
      state.pending = { kind: "pay", player: player, cost: cost, note: note, cancellable: false, varKey: key };
      return true;
    },

    picksOf(raw) {
      if (raw === undefined || raw === null) return [];
      return Array.isArray(raw) ? raw : [raw];
    },

    cardIdsOf(state, iids) {
      return iids.map(function (iid) {
        const c = Core.card(state, iid);
        return c ? c.id || c.name : null;
      });
    },

    lookMatches(state, item, iid, op) {
      const f = op.filter || {};
      if (f.type && !Core.isType(state, iid, f.type)) return false;
      if (f.hasKw && !Core.hasKw(state, iid, f.hasKw)) return false;
      if (f.types && !f.types.some(function (t) { return Core.isType(state, iid, t); })) return false;
      if (f.minEnergy !== undefined && ((Core.card(state, iid) || {}).energy || 0) < f.minEnergy) return false;
      if (f.maxEnergy !== undefined && ((Core.card(state, iid) || {}).energy || 0) > f.maxEnergy) return false;
      if (f.domain && ((Core.card(state, iid) || {}).domains || []).indexOf(f.domain) < 0) return false;
      if (f.maxMightVar !== undefined) {
        const c = Core.card(state, iid);
        const cap = (item.vars[f.maxMightVar] || 0) + (f.maxMightPlus || 0);
        if ((c && c.might) === undefined || c.might === null) return false;
        if (c.might > cap) return false;
      }
      return true;
    },

    amount(state, item, spec) {
      if (typeof spec === "number") return spec;
      if (spec === "sourceMight") {
        const src = item.source || item.iid;
        if (item.ctx && item.ctx.snapshot && item.ctx.snapshot.iid === src) return Math.max(0, item.ctx.snapshot.might || 0);
        const m = Core.effMight(state, src);
        return m === null ? 0 : m;
      }
      if (spec && typeof spec === "object") {
        let v = 0;
        if (spec.count) v = RB.Play.candidates(state, spec.count, item).length;
        else if (spec.mightOf) {
          const refs = FX.resolveRef(state, item, spec.mightOf);
          for (const t of refs) {
            const m = Core.effMight(state, t);
            if (m !== null) v += m;
          }
        }
        else if (spec.damageOf) {
          for (const t of FX.resolveRef(state, item, spec.damageOf)) {
            const o = state.objs[t];
            if (o) v += Core.totalDamage(o);
          }
        }
        else if (spec.kwOf) {
          for (const t of FX.resolveRef(state, item, spec.kwOf)) v += Core.kwVal(state, t, spec.kw);
        }
        else if (spec.energyOf) {
          const refs = FX.resolveRef(state, item, spec.energyOf);
          for (const t of refs) {
            const c = Core.card(state, t);
            if (c && typeof c.energy === "number") v += c.energy;
          }
        }
        else if (spec.chainEnergyOf) {
          for (const t of FX.resolveRef(state, item, spec.chainEnergyOf)) {
            if (typeof t !== "string" || t.indexOf("chain:") !== 0) continue;
            const it = RB.Play.itemById(state, Number(t.slice(6)));
            const c2 = it && it.iid && Core.card(state, it.iid);
            if (c2) v += c2.energy || 0;
          }
        }
        else if (spec.excessDamage) {
          const sd = state.showdown;
          v = (sd && sd.excess && sd.excess[item.controller]) || 0;
        }
        else if (spec.varOf !== undefined) v = item.vars[spec.varOf] || 0;
        else if (spec.turnFactOf !== undefined) {
          const who = spec.who === "opponent" ? Core.otherPlayer(item.controller) : item.controller;
          v = state.turnFacts.players[who][spec.turnFactOf] || 0;
        }
        else if (spec.trashName) {
          const c0 = Core.card(state, item.iid || item.source);
          const nm = typeof spec.trashName === "string" ? spec.trashName : c0 && c0.name;
          for (const tIid of state.players[item.controller].trash) {
            const tc = Core.card(state, tIid);
            if (tc && tc.name === nm) v++;
          }
        }
        else if (spec.points) {
          const who2 = spec.who === "opponent" ? Core.otherPlayer(item.controller) : item.controller;
          v = state.players[who2].points;
        }
        else if (spec.namedDamage) {
          const nm = typeof spec.namedDamage === "string" ? spec.namedDamage
            : Core.name(state, item.iid || item.source);
          v = ((state.turn.namedDamage || {})[nm]) || 0;
        }
        else if (spec.xp) v = state.players[item.controller].xp;
        else if (spec.base !== undefined) v = spec.base;
        if (spec.times !== undefined) v *= spec.times;
        if (spec.plus !== undefined) v += spec.plus;
        if (spec.min !== undefined) v = Math.max(spec.min, v);
        if (spec.max !== undefined) v = Math.min(spec.max, v);
        return v;
      }
      return 0;
    },
  };

  window.RB.FX = FX;
})();
